import TitleBlock from './views/TitleBlock';
export default TitleBlock;
